import { API_BASE_URL, ApiError } from './client';

/**
 * Writing an event's program — TROOP-158, TROOP-159.
 *
 * **There is no loader here, and no `/family` path.** The theme and the plan travel on the event's
 * own detail payload, which every door already fetches, so reading is `eventsApi.detail` and the
 * panel opens with no request of its own. A second read path would be a second place "who may see
 * this event" gets decided, which is the thing rule 13 forbids.
 *
 * A guardian reads the program the same way they read everything else about the event, and writes
 * none of it — so there is nothing for them to send and no route to give them.
 */
export interface SavedProgram {
  eventId: string;
  theme: string | null;
  plan: string | null;
  updatedAt: string;
  updatedBy: string;
}

/**
 * Both fields, always.
 *
 * They are one subject — the theme is the program's own one-line summary rather than a property of
 * the event's logistics — and a payload that could carry one of them would need a sentinel to mean
 * "leave the other alone". The four coordination flags dodge that by being nullable booleans; a
 * string has no spare value to spend, so the request simply always carries both.
 */
export async function saveProgram(
  unitId: string,
  eventId: string,
  body: { theme: string | null; plan: string | null },
): Promise<SavedProgram> {
  const response = await fetch(
    `${API_BASE_URL}/units/${unitId}/events/${eventId}/program`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );

  if (!response.ok) {
    throw new ApiError(response.status, `PUT program for ${eventId} failed`);
  }

  return (await response.json()) as SavedProgram;
}
